module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "h6"
    }
  }, [_vm._v("Author’s Notes")])]), _c('a', {
    attrs: {
      "id": "h6"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_vm._v("I")]), _vm._v("n many cases, passages quoted from books and other documents have been edited to substitute lower case for upper case letters (e.g. the word ‘tank’ was commonly written ‘Tank’), and to simplify or clarify punctuation. Tank names have been italicised.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The village of Flesquières was frequently misspelled at the time (the accent proving a particular bugbear), and in general I have replicated the spelling used in the original documents. See also the note below on the spelling of Belgian place-names.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As far as possible, an individual’s rank is shown at the time of the events in question, or at the time he wrote a book or article (which may result in different ranks being shown for the same person).")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In general, the quotes from German books have been quite freely translated to give a sense of the original meaning. The writers were frequently imprecise about the nationality of their enemies (they often used ‘English’ to mean ‘British’, and described Scottish troops as ‘English’ or even ‘Canadian’). In these cases, the original terms have been followed in the translation.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "h6"
    }
  }, [_vm._v("In some cases, longer extracts and copies of original documents are shown on the website supporting this book: ")]), _c('a', {
    attrs: {
      "href": "http://www.deborah-tank.co.uk",
      "target": "_blank"
    }
  }, [_vm._v("www.deborah-tank.co.uk")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Every effort has been made to contact copyright holders for permission to use material, and anyone with a potential concern about this is requested to contact the publisher.")]), _vm._v(" "), _c('h3', {
    staticClass: "h3"
  }, [_vm._v("Abbreviations")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "15%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "85%"
    }
  })]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Bn")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Battalion")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("CWGC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Commonwealth War Graves Commission")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("HQ")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Headquarters")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("ICRC")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("International Committee of the Red Cross")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("IWM")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Imperial War Museum")])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("NA")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("National Archives")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d5eb184","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/09_authors.vue
// module id = 87
// module chunks = 0